import React, { VFC } from 'react';
import { useNavigate, useResolvedPath, useMatch } from 'react-router-dom';
import { EASYCOM_ROUTES } from '../../navigation';
import Tab from '../molecules/Tab';
import { useAppInit } from '../../contexts/appInitContext';

const Tabs: VFC = () => {
  const { params } = useAppInit();
  const { allowOrderFiltering } = params;
  const navigate = useNavigate();

  const tabs = [
    {
      title: 'Order',
      onClick: () => navigate(EASYCOM_ROUTES.ORDER_PAGE),
      to: '/order',
    },
  ];

  if (allowOrderFiltering) {
    tabs.push({
      title: 'Product',
      onClick: () => navigate(EASYCOM_ROUTES.PRODUCT_PAGE),
      to: '/product',
    });
  }

  return (
    <>
      {tabs.map(({ onClick, title, to }) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const resolved = useResolvedPath(to);
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const match = useMatch({ path: resolved.pathname, end: true });

        return (
          <Tab key={title} onClick={onClick} active={!!match}>
            {title}
          </Tab>
        );
      })}
    </>
  );
};

export default Tabs;
